<div *ngIf="text" class="ion-padding" style="padding-bottom: 2px;">
  <div class="password-strength-description" >
    <p><strong>Your password needs to have:</strong></p>
    <p *ngFor="let error of errors" [ngClass]="{valid: error.valid == true}">
      <span *ngIf="error.valid == true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8ZM11.5938 6.625C11.9375 6.28125 11.9375 5.75 11.5938 5.40625C11.25 5.0625 10.7188 5.0625 10.375 5.40625L7 8.78125L5.59375 7.40625C5.25 7.0625 4.71875 7.0625 4.375 7.40625C4.03125 7.75 4.03125 8.28125 4.375 8.625L6.375 10.625C6.71875 10.9688 7.25 10.9688 7.59375 10.625L11.5938 6.625Z" fill="#8BBD1E"/>
        </svg>
        </span>
      <span *ngIf="error.valid == false">
        <span class="round-circle"></span>
      </span>
    {{error.message}}</p>
  </div>
</div>
